import { createReduxAsyncThunk } from 'shared/utils';
import { carsAPI } from 'entities/cars';

import { CARS_STATE } from '../../constants';

import { CarsState } from '../../types';

export const getADRClasses = createReduxAsyncThunk<CarsState['adrClasses']['data']>(
  `${CARS_STATE}/getADRClasses`,
  async () => {
    const { data } = await carsAPI.getADRClasses();
    return data;
  }
);